var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.src[_vm.imageIndex])?_c('div',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-row',[_c('img',{staticClass:"preview",attrs:{"src":_vm.src[_vm.imageIndex][_vm.language],"alt":"preview"}})])],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }